import type { ReactNode } from "react";
import type { CursorListResult } from "../lib/useCursorList";
import { Button, ErrorState, SkeletonBlock } from "./ui";

// Loading, error, empty and "load more" for a keyset-paginated list — one
// rendering of §6's shared states for every list screen.

export function CursorListView<Row>({
  list,
  empty,
  loadingLabel,
  children,
}: {
  list: CursorListResult<Row>;
  empty: ReactNode;
  loadingLabel: string;
  children: (rows: Row[]) => ReactNode;
}) {
  const { query } = list;
  if (query.isPending) return <SkeletonBlock label={loadingLabel} lines={3} />;
  if (query.isError && list.rows.length === 0) return <ErrorState error={query.error} onRetry={() => void query.refetch()} />;
  if (list.rows.length === 0) return <>{empty}</>;
  return (
    <div className="stack">
      {children(list.rows)}
      {query.isFetchNextPageError ? <ErrorState error={query.error} /> : null}
      {list.hasMore ? (
        <div>
          <Button variant="secondary" size="sm" onClick={list.loadMore} loading={list.loadingMore}>
            Load more
          </Button>
        </div>
      ) : null}
    </div>
  );
}
